import { Box, Stack } from '@mui/material'
import React from 'react'
import { Header } from 'src/components/header/Header'
import { HeaderTitle } from 'src/components/header/HeaderTitle'
import ApprovalReports from 'src/features/approvals/ApprovalReports'

const ApprovalListScene: React.FC = () => {
  return (
    <Stack sx={{ height: 'calc(100vh - var(--banner-height, 0px))' }}>
      <Box sx={{ height: 72, flexShrink: 0 }}>
        <Header>
          <HeaderTitle title="承認" />
        </Header>
      </Box>
      <ApprovalReports />
    </Stack>
  )
}

export default ApprovalListScene
